import React from 'react';
import {
  type IDataAttributeMap,
  Select,
  SelectOption,
  type SelectVariant,
  Typography,
  TypographyVariant,
} from '@secretescapes/falcon';
import { type Option } from '../DropdownInput';
import { Container, SelectOptionWrapper, StyledSelect } from './CustomSelect.styles';

export interface CustomSelectProps {
  label: string;
  options: Option[];
  value: string | number;
  variant: SelectVariant;
  animate?: boolean;
  dataAttributes?: IDataAttributeMap;
  className?: string;
  fixedWidth?: boolean;
  onSelect: (newValue: string) => void;
  onAnimationEnd?: () => void;
}

export const CustomSelect = ({
  label,
  options,
  value,
  variant,
  animate,
  dataAttributes,
  className,
  fixedWidth,
  onSelect,
  onAnimationEnd,
}: CustomSelectProps) => {
  return (
    <Container className={className}>
      <Typography variant={TypographyVariant.b3}>{label}</Typography>
      <StyledSelect
        data-testid="custom-select"
        variant={variant}
        animate={animate}
        onAnimationEnd={onAnimationEnd}
        fixedWidth={fixedWidth}
      >
        <Select
          dataAttributes={dataAttributes}
          title={label}
          embeddedLabel={false}
          zIndex={5}
          selected={options.find(option => option.value === value)?.text ?? ''}
          variant={variant}
        >
          {({ close }) => (
            <SelectOptionWrapper>
              {options.map(({ value, text, subtext }) => (
                <SelectOption
                  variant={variant}
                  id={value}
                  key={value}
                  title={text}
                  subtitle={subtext}
                  onClick={() => {
                    close();
                    onSelect(value);
                  }}
                />
              ))}
            </SelectOptionWrapper>
          )}
        </Select>
      </StyledSelect>
    </Container>
  );
};
